import { useTranslation } from "react-i18next";
import EmptyState from "@/shared/components/ui/empty-state/empty-state.tsx";

interface MachinesLiveEmptyProps {
  compact?: boolean;
}

const MachinesLiveEmpty = ({ compact = false }: MachinesLiveEmptyProps) => {
  const { t } = useTranslation("machines");

  return (
    <div className="w-full h-full flex items-center justify-center">
      <EmptyState 
        title={t("live.empty.title")}
        description={t("live.empty.description")}
        compact={compact}
        showBorder={false}
      />
    </div>
  );
};

export default MachinesLiveEmpty;
